import fp from 'lodash/fp';
import React, { useMemo } from 'react';
import { FormSpyRenderProps } from 'react-final-form';
import { forms } from '@factorin/container.macro';

import { Text, cn, ClassName } from 'Modules/ui';

import styles from './index.module.scss';


const finalFormArrayError = 'FINAL_FORM/array-error';


interface ArrayErrorsComponentProps extends FormSpyRenderProps, ClassName {
    errorKeys: string[];
}

export const ArrayErrorsComponent: React.FC<ArrayErrorsComponentProps> = React.memo(({
    errors,
    errorKeys,
    className,
}) => {
    const error = useMemo(
        () => fp.pipe(
            fp.map((key:string) => fp.get(key, errors)),
            fp.map(fp.get(finalFormArrayError)),
            fp.compact,
            fp.first,
        )(errorKeys),
        [errors, errorKeys],
    );
    return (
        <Text component='div' className={cn(styles.error, className)}>
            {error && <forms.errorRenderer error={error.key} />}
        </Text>
    );
});
